<template>
  <div class="wrapper">
    <div class="nav-seat"></div>
    <div class="banner">
      <el-carousel height="366px">
        <el-carousel-item v-for="(v,i) in bannerList" :key="i">
          <el-image :src="v.image" @click="openUrl(v)"></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="btn">
      <div class="b-top">
        <div class="title">Hi，欢迎登录</div>
        <div class="group">
          <div class="g-left" @click="goAdmin('login')">用户登录</div>
          <div class="g-right" @click="goAdmin('register')">免费注册</div>
        </div>
      </div>
      <div class="b-bottom" @click="$router.push('/qrcode')">
        <el-image :src="require('@/assets/home/qrcode.png')"></el-image>
        <div class="title">二维码生成器</div>
      </div>
    </div>
  </div>
</template>

<script>
import {getCity} from "@/utils/locate";

export default {
  name: "NavBannerBtn",
  data() {
    return {
      bannerList: []
    }
  },
  computed: {
    city() {
      return getCity()
    }
  },
  created() {
    this.$request.get('/Home/banner', {
      params: {
        areaId: this.city.areaId
      }
    }).then(res => {
      if (res.code === 0) {
        this.bannerList = res.data
      }
    })
  },
  methods: {
    /**
     * 打开外链
     * @param url
     */
    openUrl({url}) {
      if (url) {
        window.open(url, '_blank')
      }
    },
    /**
     * 去管理对应页面
     * @param key
     */
    goAdmin(key) {
      const location = window.location;
      const url = `${location.protocol}//${location.hostname}${location.port ? ':8001' : ''}/platform/#/${key}`
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  width: 100%;
  height: 366px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .nav-seat {
    width: 204px;
    height: 100%;
    background-color: #FFFFFF;
    border-radius: 8px;
  }

  .banner {
    width: 700px;
    height: 100%;
    background-color: #FFFFFF;
    border-radius: 8px;
    overflow: hidden;
  }

  .btn {
    width: 256px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .b-top {
      height: 160px;

      .title {
        color: #2D2D2D;
        font-size: 20px;
        font-weight: bold;
      }

      .group {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        margin-top: 20px;

        .g-left, .g-right {
          width: 96px;
          height: 32px;
          cursor: pointer;
          border-radius: 4px;
          font-weight: bold;
          font-size: 16px;
          text-align: center;
          line-height: 32px;
        }

        .g-left {
          background-color: #F0F1F5;
          color: #2D2D2D;
          margin-right: 10px;
        }

        .g-right {
          background-color: #1464FF;
          color: #FFFFFF;
        }
      }
    }

    .b-bottom {
      height: 186px;
      cursor: pointer;

      .el-image {
        width: 80px;
        height: 84.27px;
      }

      .title {
        color: #2D2D2D;
        font-size: 20px;
        font-weight: bold;
        margin-top: 10px;
      }
    }

    .b-top, .b-bottom {
      width: 100%;
      border-radius: 8px;
      background-color: #FFFFFF;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>